module.exports = __webpack_public_path__ + "static/Visualsoft-271ff15294dc5aaf6b86220d1111daf2.svg";